// extracted by mini-css-extract-plugin
export var parcelRow = "_r2-0";